import React from 'react';

import 'bootstrap/dist/css/bootstrap.css';
import './index.css';

import Navbar from './components/navbar';
import Header from './components/header';
import Facebook from '../public/facebook.png'
import Instagram from '../public/instagram.png';
import Twitter from '../public/twitter.png';
import Gf from '../public/gf.png';

const App = ({children}) => {
  return (
    <div>
      <Header />
      <Navbar />
      <div className="container">
        {children}
      </div>
      <footer>
        <div className="container">
            <div className="row">
                <div className="col-lg-12 text-center">
                    <p>
                    <img src={Gf} target="_blank" rel="noopener" alt="GF"/>
                    Copyright &copy; Posada El Capullo 2024 || Colonia del Sacramento.
                    <span style={{ paddingLeft: '35px' }}>
                      <a  href="https://www.facebook.com/PosadaElCapullo" target="_blank" rel="noopener">
                        <img className="logo-fb" src={Facebook} alt="facebook" />
                      </a>
                      <a href="https://www.instagram.com/elcapulloposada" target="_blank" rel="noopener" >
                        <img className="logo-ig" src={Instagram} alt="instagram" />
                      </a>
                      <a href="https://twitter.com/capulloposada" target="_blank" rel="noopener" >
                        <img style={{marginLeft: '3px'}} className="logo-ig" src={Twitter} alt="twitter"/>
                      </a>
                    </span>
                    </p>
                </div>
            </div>
        </div>
      </footer>
    </div>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js